<template>
  <div class="container border rounded mb-2">
    <i class="bi bi-x-lg float-end text-danger" @click="closeAuction()"></i>
    <div class="row">
      <div class="col-md-4 border rounded">
        <SelectPlayer v-if="auction.select_live_player"></SelectPlayer>
        <!-- <HardSale v-if="auction.hard_sale"></HardSale> -->
        <LivePools></LivePools>
      </div>
      <div class="col-md-4 border rounded"><LivePlayer></LivePlayer></div>
      <div class="col-md-4 border rounded">
        <SoldPlayers></SoldPlayers>
      </div>
    </div>
    <div class="row" v-if="auction.enable_assist">
      <div class="col"><AssistHome></AssistHome></div>
    </div>
    <div class="row" v-if="auction.enable_flash">
      <div class="col"><FlashHome></FlashHome></div>
    </div>
    <div class="row border rounded mt-2">
      <TeamsStatus></TeamsStatus>
    </div>
  </div>
</template>
<script setup>
import { useStore } from "@/store/index";
import { ref, onMounted, onBeforeUnmount } from "vue";
import supabase from "@/supabase/config";
import LivePools from "../livepools/LivePools.vue";
import LivePlayer from "../liveplayer/LivePlayer.vue";
import FlashHome from "../flash/FlashHome.vue";
import AssistHome from "../assist/AssistHome.vue";
import SoldPlayers from "../soldplayers/SoldPlayers.vue";
import TeamsStatus from "../../bidder/teamsstatus/TeamsStatus.vue";
import SelectPlayer from "../livepools/SelectPlayer.vue";
import HardSale from "../livepools/HardSale.vue";
const store = useStore();
const auction = ref({});
const closeAuction = () => {
  setLivePlayerToNull();
  setBiddingOpenToFalse();
  setTimeout(() => {
    store.setAuction("");
  }, 200);
};
const setLivePlayerToNull = async () => {
  const { data, error } = await supabase
    .from("auctions")
    .update({ live_player_id: null })
    .eq("id", store.live_auction)
    .select();
};
const setBiddingOpenToFalse = async () => {
  const { data, error } = await supabase
    .from("auctions")
    .update({ bidding_open: false })
    .eq("id", store.live_auction)
    .select();
};
onMounted(() => {
  setTimeout(() => {
    fetchAuction();
  }, 1000);
  setTimeout(() => {
    if (auction.value.live_player_id) {
      setLivePlayerToNull();
    }
  }, 2500);
});
// onBeforeUnmount(() => {
//   console.log("setting live player to null...");
//   setLivePlayerToNull();
// });
const fetchAuction = async () => {
  auction.value = {};
  let { data: auctions, error } = await supabase
    .from("auctions")
    .select("*")
    .eq("id", store.live_auction);
  auction.value = auctions[0];
};
</script>
<style scoped>
.tinytxt {
  font-size: 10px;
  padding: 2px;
}
</style>
